var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbars',{attrs:{"objects":_vm.notifications,"top":"","right":""},on:{"update:objects":function($event){_vm.notifications=$event}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var close = ref.close;
var index = ref.index;
var message = ref.message;
var id = ref.id;
return [_c('v-btn',{attrs:{"icon":"","color":"white","text":""},on:{"click":function($event){return close()}}},[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }